import React from 'react';
var ModalContext = React.createContext({
  onHide: function onHide() {}
});
export default ModalContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/es/ModalContext.js
// module id = 149
// module chunks = 0